module.exports = __webpack_public_path__ + "static/media/cinema.5f886995.jpg";